import { NgModule } from '@angular/core';
import { UnitPipe } from './specification/unit.pipe';
import { DateTimePipe } from './date/date-time.pipe';
import { DashPipe } from './dash/dash.pipe';
import { WorkingLiftingHeightPipe } from './working-lifting-height/working-lifting-height.pipe';
import { CountryPipe } from './country/country.pipe';
import { TranslateOpcoPipe } from './translate/translate-opco.pipe';
import { TranslateApplicationNamePipe } from './translate/translate-application-name.pipe';
import { TranslateProductPipe } from './translate/translate-product.pipe';
import { TranslateRolePipe } from './translate/translate-role.pipe';

@NgModule({
    imports: [UnitPipe,
        DateTimePipe,
        DashPipe,
        WorkingLiftingHeightPipe,
        CountryPipe,
        TranslateOpcoPipe,
        TranslateProductPipe,
        TranslateApplicationNamePipe,
        TranslateRolePipe],
    exports: [
        UnitPipe,
        DateTimePipe,
        DashPipe,
        WorkingLiftingHeightPipe,
        CountryPipe,
        TranslateOpcoPipe,
        TranslateProductPipe,
        TranslateApplicationNamePipe,
        TranslateRolePipe
    ],
    providers: []
})
export class CommonPipeModule {}
